export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 13 Parking Lot Lost.c3cbc475.mp3";